import React, { useState } from "react";
import styles from "./NewProduct.module.sass";

import ProspectInformation from "./ProspectInformation";
import CandidateList from "./CandidateList";

const CandidateListView = ({ offer }) => {
    const [candidateListKey, setCandidateListKey] = useState(0);

    return (
        <>
            <div className={styles.shop}>
                <div className={styles.row}>
                    <div className={styles.col}>
                        <ProspectInformation
                            className={styles.card}
                            offer={offer}
                            onProspectAdded={() => {
                                setCandidateListKey(prev => prev + 1);
                            }}
                        />
                        <CandidateList
                            key={candidateListKey}
                            className={styles.card}
                            offer={offer}
                            readOnly={true}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default CandidateListView;
